<template>
  <div
    @click="handleFileClick"
  >
    <div v-if="options.viewMode === 'img'">
      <img
        v-for="(file, key) in defaultFileList"
        :key="key"
        :src="file.url"
        :alt="file.name"
        style="max-width: 100%;"
      >
    </div>
    <a-upload
      v-else
      :disabled="true"
      :file-list="defaultFileList"
      :remove="() => false"
      list-type="picture-card"
      @preview="openFile"
    />
  </div>
</template>

<script>
import FieldViewer from '@/components/fields/FieldViewer'
import Api from '@/api'
import { openWebhookResponse } from '@/webhooks'
import { getFileURL } from '@/utils'

export default {
  name: 'FieldViewerFile',
  extends: FieldViewer,
  watch: {
    value () {
      this.getFileList()
    },
  },
  mounted () {
    this.getFileList()
  },
  methods: {
    handleFileClick (event) {
      if (event.target.classList.contains('ant-upload-list-item-info')) {
        let icon = event.target.parentNode.querySelector('.anticon.anticon-eye-o')
        icon.click()
      }
    },
    openFile (file) {
      Api.files().getFile(file.uid).then(blob => openWebhookResponse(blob, file.name))
    },
    getPreviewUrl (mime, url) {
      if (mime === 'application/pdf') {
        return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='64 64 896 896' data-icon='file-pdf' width='20px' height='20px' fill='red' %3E%3Cpath d='M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'%3E%3C/path%3E%3C/svg%3E"
      }
      if (mime.includes('word')) {
        return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='64 64 896 896' data-icon='file-word' width='20px' height='20px' fill='blue' aria-hidden='true' focusable='false' class=''%3E%3Cpath d='M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z'%3E%3C/path%3E%3C/svg%3E"
      }
      if (mime.includes('image') && !mime.includes('svg')) {
        return url
      }
      return ''
    },
    getFileList () {
      let fileList = []
      let value = this.value
      if (value) {
        if (this.fieldIsScalar) {
          value = [value]
        }
        value.forEach(item => {
          if (item.directory) {
            fileList.push({
              'uid': item.id,
              'name': item.brezel_name,
              'status': 'done',
              'url': '',
            })
            return
          }
          getFileURL(item.id, 'default')
            .then(url => {
              fileList.push({
                'uid': item.id,
                'name': item.brezel_name,
                'status': 'done',
                'url': this.getPreviewUrl(item.mime_type, url),
              })
            })
            .catch(() => {
              fileList.push({
                'uid': item.id,
                'name': item.brezel_name,
                'status': 'done',
              })
            })
        })
      }
      this.defaultFileList = fileList
    },
  },
}
</script>

<style scoped>

</style>
